import React from 'react';
import { Box, Fade } from '@mui/material';

const DOTS = [
  { delay: '0s' },
  { delay: '0.3s' },
  { delay: '0.6s' },
];

const FCLLoadingScreen: React.FC = () => (
  <Fade in timeout={300}>
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        background: '#0A1929',
        '@keyframes dotPulse': {
          '0%':   { opacity: 0.2 },
          '50%':  { opacity: 1   },
          '100%': { opacity: 0.2 },
        },
      }}
    >
      <Box
        component="img"
        src="/logo192.png"
        alt="FCL"
        sx={{
          width: 80,
          height: 80,
          userSelect: 'none',
        }}
      />

      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {DOTS.map((d, i) => (
          <Box
            key={i}
            sx={{
              width: 4,
              height: 4,
              borderRadius: '50%',
              bgcolor: 'rgba(30, 136, 229, 0.8)',
              animation: `dotPulse 0.9s ease-in-out ${d.delay} infinite`,
            }}
          />
        ))}
      </Box>
    </Box>
  </Fade>
);

export default FCLLoadingScreen;
